 const VHAMSTER_LPADDR = '0xF7145aE0B1c1F1785c7e8101F29f08112f3D5f6A'

 const VHAMSTER_PLEDGE_ADDR = '0x3a30b35D2BEA888D08dEC9ddD55ADcF8b6EAe7f2'

 export  { VHAMSTER_LPADDR, VHAMSTER_PLEDGE_ADDR }